export default __webpack_public_path__ + "static/media/ic_drivers_off.1b4752d8.svg";